import { TimeOption } from "../../../../utils/utils";

export const getDefaultShowAdvancedSectionForGoOrder = (
	autoLinkByName: boolean,
	externalDelivery: boolean,
	itemMultiLevel: boolean,
	defaultStores?: { label: any; id: any }[],
	defaultTerminals?: { label: any; id: any }[],
	defaultCustomFields?: { label: any; value: any }[],
	pointOfSaleId?: string,
	numberOfTimeUnits?: number | string,
	timeUnit?: { value: TimeOption; label: string },
	orderAcceptType?: { value: string; label: string },
	imageTag?: string
) => {
	return !!(
		(defaultStores && defaultStores?.length > 0) ||
		(defaultTerminals && defaultTerminals?.length > 0) ||
		(defaultCustomFields && defaultCustomFields?.length > 0) ||
		autoLinkByName ||
		externalDelivery ||
		itemMultiLevel ||
		pointOfSaleId ||
		(numberOfTimeUnits !== undefined && numberOfTimeUnits !== "") ||
		timeUnit ||
		orderAcceptType ||
		imageTag
	);
};
